import { Divider, Grid, Box, Typography } from '@mui/material';
import React from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
function Footer() {
  return (
    <Box sx={{ color: 'white' }}>
      <Grid
        container
        justifyContent={'space-between'}
        alignItems="center"
        sx={{ background: '#f9fdfc',py:4}}
        className="container">
        <Grid item xs={12} md={4} sx={{display:'flex',flexDirection:'column',rowGap:1}}>
          <Typography variant="body1" color={'text.secondary'} fontWeight={600}>
            ارتباط با ما
          </Typography>
          <Typography
            variant="body2"
            color={'text.secondary'}
            width={'70%'}
            sx={{ mt: 2 }}>
            
          </Typography>
          <Box
            component={'div'}
            color={'primary.main'}
            sx={{ display: 'flex', alignItems: 'center',gap:1 }}>
            <Box
              sx={{
                border: 1,
                display: 'inline-block',
                border: '1px solid #e2edea',
              }}>
              <PhoneIcon />
            </Box>
            <Typography variant="caption" color="text.secondary">
            ۰۰۰۰ ۹۰۰۰۰۰۰۰ ۹۰۰۰
            </Typography>
          </Box>
          <Box
            component={'div'}
            color={'primary.main'}
            sx={{ display: 'flex', alignItems: 'center',gap:1 }}>
            <Box
              sx={{
                border: 1,
                display: 'inline-block',
                border: '1px solid #e2edea',
              }}>
              <EmailIcon />
            </Box>
            <Typography variant="caption" color="text.secondary">
            info@asiatech.ir
            </Typography>
            
          </Box>
          <Box
            component={'div'}
            color={'primary.main'}
            sx={{ display: 'flex', alignItems: 'center',gap:1 }}>
            <Box
              sx={{
                border: 1,
                display: 'inline-block',
                border: '1px solid #e2edea',
              }}>
              <LocationOnIcon />
            </Box>
            <Typography variant="caption" color="text.secondary">
            خیابان مطهری، خیابان میرعماد نرسیده به خیابان بهشتی، نبش کوچه
            دوازدهم، پلاک ۳۷
            </Typography>
          </Box>
        </Grid>

        {/* <Grid item xs={12} md={4} sx={{display:'flex',flexDirection:'column',rowGap:1}}>
          <Typography variant="body1" color={'text.secondary'} fontWeight={600} >ارتباط با ما</Typography>
        </Grid> */}

        <Grid item xs={12} md={4} sx={{display:'flex',flexDirection:'column',rowGap:1}}>
          
          <Typography variant="h4" color={'text.secondary'} fontWeight={600} textAlign="center" >نماد الکترونیکی</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Footer;
